"use client";
import { useTranslations } from "next-intl";
import { usePathname } from "next/navigation";
import Image from "next/image";
import Link from "next/link";
import clsx from "clsx";

import Rating from "@/shared/components/Rating";
import AppStoreButton from "@/shared/components/AppStoreButton";
import { LinkView } from "@/shared/components/SectionLink";
import Logo from "@/shared/components/Logo";
import QRCode from "@/shared/components/QRCode";
import { PATHS } from "@/shared/utils/paths";

import homeIcon from "@public/home_icon.png";

import s from "./styles.module.css";

interface Props {
  className?: string;
}
export default function InstallSection({ className }: Props) {
  const t = useTranslations("InstallSection");

  const path = usePathname();

  return (
    <section className={clsx(s.container, className)}>
      <div className={s.install}>
        <h2 className={s.installTitle}>{t("installSweatWallet")}</h2>
        <div className={s.installButtons}>
          <div className={s.qrcode}>
            <QRCode />
          </div>
          <AppStoreButton />
          <Rating />
        </div>
      </div>
      {path !== PATHS.home && (
        <Link
          href={PATHS.home}
          className={clsx(
            s.innerLink,
            s.innerLinkHome,
            path === PATHS.wallet ? s.area2 : s.area1
          )}
        >
          <Image
            className={s.homeIcon}
            width={56}
            src={homeIcon}
            alt="home logo"
          />
          <LinkView className={s.innerSectionLink}>{t("linkHome")}</LinkView>
        </Link>
      )}
      {path !== PATHS.token && (
        <Link
          href={PATHS.token}
          className={clsx(s.innerLink, s.innerLinkToken)}
        >
          <Logo type="round" className={s.innerLinkLogo} />
          <LinkView className={s.innerSectionLink}>
            {t("linkTheToken")}
          </LinkView>
        </Link>
      )}
      {path !== PATHS.wallet && (
        <Link
          href={PATHS.wallet}
          className={clsx(s.innerLink, s.innerLinkWallet)}
        >
          <Logo type="square" className={s.innerLinkLogo} />
          <LinkView className={s.innerSectionLink}>
            {t("linkTheWallet")}
          </LinkView>
        </Link>
      )}
    </section>
  );
}
